<template>
  <div class="text-center mx-auto">
    <div class="py-4 px-4 border border-black items-center leading-none rounded-lg" role="alert">
      <span class="text-center">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  props: {
    text: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
